import React from "react";
import {
  Flex,
  HStack,
  Stack,
  VStack,
  Box,
  Drawer,
  DrawerOverlay, 
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  useDisclosure,
  IconButton,
} from "@chakra-ui/react";
import { FiMenu } from "react-icons/fi";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

const Layout = () => {
  const { isOpen, onOpen, onClose }  = useDisclosure();

  return (
    <VStack h="100vh" w="100vw" align="flex-start" spacing={0} overflow="hidden">
      {/* Header */}
      <HStack bg="#fff" w="full" h="16" px={4} justify="space-between">
        {/* Mobile Menu Button */}
        <IconButton
          display={{ base: "flex", lg: "none" }}
          icon={<FiMenu />}
          aria-label="Open Menu"
          onClick={onOpen}
          variant="outline"
        />
        <Header />
      </HStack>

      {/* Body */}
      <Flex h="full" w="full" position="relative">
        {/* Desktop Sidebar */}
        <Box
          display={{ base: "none", lg: "block" }}
          position="fixed"
          top="4rem"
          left="0"
          height="calc(100vh - 4rem)"
          width="13rem"
          bg="#fff"
          overflowY="auto"
          zIndex="100"
          borderRight="1px solid #eee"
          sx={{
            scrollbarWidth: "none", // Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Chrome/Safari
            },
          }}
        >
          <Sidebar />
        </Box>

        {/* Mobile Sidebar (Drawer) */}
        <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Menu</DrawerHeader>
            <DrawerBody>
              <Sidebar onClose={onClose} />
            </DrawerBody>
          </DrawerContent>
        </Drawer>

        {/* Main Content */}
        <Stack
          h="calc(100vh - 4rem)"
          w="full"
          ml={{ base: "0", lg: "13rem" }}
          overflowY="auto"
          bg="#FAFBFE"
          p="20px"
          sx={{
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Outlet />
        </Stack>
      </Flex>
    </VStack>
  );
};

export default Layout;
